// import "./App.scss";
// import React, { useEffect } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// import { onMessage } from "firebase/messaging";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
// import Header from "./components/Header/Header";
// import Register from "./pages/Register/Register";
// import Dailyincome from "./pages/Dailyincome/Daily_income";
// import Login from "./pages/Login/Login";
// import Myincome from "./pages/Myincome/Myincome";
// import Myprofile from "./pages/Myprofile/Myprofile";
// import Myrank from "./pages/Myrank/Myrank";
// import Myteam from "./pages/Myteam/Myteam";
// import Home from "./pages/Home/Home";
// import Postlogin from "./pages/PostLogin/Postlogin";
// import Forgot from "./pages/ForgotPassword/forgot";
// import Otp from "./components/OTP/Otp";
// import Newpassword from "./components/NewPassword/NewPassword";
// import Logotp from "./components/logotp/logotp";
// import About from "./pages/About/About";
// import Privacy from "./pages/privacy/Privacy";
// import Profile from "./pages/Profile/Profile";
// import Auth from "./context/Auth";
// import Products from "./pages/Myproducts/Myproducts";
// import Achivers from "./pages/Achivers/Achivers";
// import Widthhistory from "./pages/Withhistory/Widthhistory";
// import Upgradehistory from "./pages/Withhistory/Upgradehistory";
// import Activation from "./pages/Activation/Activation";
// import Addtransaction from "./pages/Activation/Addtransaction";
// import { generateToken, messaging } from "./components/firebase/firebase";
// import Setpin from "./pages/SetpinActivation/SetpinActivation";
// import Wahtsappstatus from "./pages/Wahtsappstatus/Wahtsappstatus";
// import Activepass from "./pages/Myincome/Activepass";
// import ChatList from "./pages/ChatScreens/Chatlist";
// import ChatView from "./pages/ChatScreens/ChatView";
// import Resetpin from "./pages/SetpinActivation/Resetpin";
// import MyProject from "./pages/Myproject/MyProject";
// import ContactUs from "./pages/ContactUs/ContactUs";
// import Repurchasetransaction from "./pages/Activation/Repurchasetransaction";
// import LandingPage from "./pages/Landing/Landing";
// import MyAdvertisements from "./pages/Myads/MyAdvertisements";
// // import Scene from "./pages/Myads/EnterMall";

// function App() {
//   const location = useLocation();
//   const hideHeaderPaths = ['/my_ads'];

//   const shouldShowHeader = !hideHeaderPaths.includes(location.pathname);
//   useEffect(() => {
//     onMessage(messaging, (payload) => {
//       console.log(payload, "payloaddddd");
//       toast.success(payload.notification.body);
//     });
//     generateToken();
//   }, []);
//   return (
//     <>

//       <userContext></userContext>
//       <BrowserRouter>
//         <Auth>
//           <Header />
//           <Routes>

//             {/* <Route path="/" element={<LandingPage />} /> */}
//             <Route path="/" element={<Login />} />
//             {/* <Route path="/" element={<Login />} /> */}
//             <Route path="/register" element={<Register />} />
//             <Route path="/income" element={<Dailyincome />} />
//             <Route path="/my_income" element={<Myincome />} />
//             <Route path="/my_profile" element={<Myprofile />} />
//             <Route path="/my_rank" element={<Myrank />} />
//             <Route path="/my_team" element={<Myteam />} />
//             <Route path="/home" element={<Home />} />
//             <Route path="/post_login" element={<Postlogin />} />
//             <Route path="/forgot" element={<Forgot />} />
//             <Route path="/otp" element={<Otp />} />
//             <Route path="/logotp" element={<Logotp />} />
//             <Route path="/new_password" element={<Newpassword />} />
//             <Route path="/change_password" element={<Newpassword />} />

//             <Route path="/about" element={<About />} />
//             <Route path="/privacy" element={<Privacy />} />
//             <Route path="/profile" element={<Profile />} />
//             <Route path="/my-products" element={<Products />} />
//             <Route path="/achivers" element={<Achivers />} />
//             <Route path="/Widthhistory" element={<Widthhistory />} />
//             <Route path="/Upgradehistory" element={<Upgradehistory />} />
//             <Route path="/Activation" element={<Activation />} />
//             <Route path="/Addtransaction" element={<Addtransaction />} />
//             <Route path="/Setpin" element={<Setpin />} />
//             <Route path="/Resetpin" element={<Resetpin />} />

//             <Route path="/Status" element={<Wahtsappstatus />} />

//             <Route path="/Activepass" element={<Activepass />} />

//             <Route path="/Chat" element={<ChatList />} />
//             <Route path="/ChatView/:c_id" element={<ChatView />} />
//             <Route path="/MyProject" element={<MyProject />} />
//             <Route path="/ContactUs" element={<ContactUs />} />
//             <Route
//               path="/Repurchasetransaction"
//               element={<Repurchasetransaction />}
//             />
//             <Route path="/my_ads" element={<MyAdvertisements />} />
//           </Routes>
//         </Auth>
//       </BrowserRouter>
//     </>
//   );
// }

// export default App;
import "./App.scss";
import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { onMessage } from "firebase/messaging";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header/Header";
import Register from "./pages/Register/Register";
import Dailyincome from "./pages/Dailyincome/Daily_income";
import Login from "./pages/Login/Login";
import Myincome from "./pages/Myincome/Myincome";
import Myprofile from "./pages/Myprofile/Myprofile";
import Myrank from "./pages/Myrank/Myrank";
import Myteam from "./pages/Myteam/Myteam";
import Home from "./pages/Home/Home";
import Postlogin from "./pages/PostLogin/Postlogin";
import Forgot from "./pages/ForgotPassword/forgot";
import Otp from "./components/OTP/Otp";
import Newpassword from "./components/NewPassword/NewPassword";
import Logotp from "./components/logotp/logotp";
import About from "./pages/About/About";
import Privacy from "./pages/privacy/Privacy";
import Profile from "./pages/Profile/Profile";
import Auth from "./context/Auth";
import { CartProvider } from "./context/CartContext";
import Products from "./pages/Myproducts/Myproducts";
import Achivers from "./pages/Achivers/Achivers";
import Widthhistory from "./pages/Withhistory/Widthhistory";
import Upgradehistory from "./pages/Withhistory/Upgradehistory";
import Activation from "./pages/Activation/Activation";
import Addtransaction from "./pages/Activation/Addtransaction";
// import { generateToken, messaging } from "./components/firebase/firebase";
import Setpin from "./pages/SetpinActivation/SetpinActivation";
import Wahtsappstatus from "./pages/Wahtsappstatus/Wahtsappstatus";
import Activepass from "./pages/Myincome/Activepass";
import ChatList from "./pages/ChatScreens/Chatlist";
import ChatView from "./pages/ChatScreens/ChatView";
import Resetpin from "./pages/SetpinActivation/Resetpin";
import MyProject from "./pages/Myproject/MyProject";
import ContactUs from "./pages/ContactUs/ContactUs";
import Repurchasetransaction from "./pages/Activation/Repurchasetransaction";
import MyAdvertisements from "./pages/Myads/MyAdvertisements";
import LandingPage from "./pages/Landing/Landing";
import BuySellButtons from "./pages/Myincome/olx";
import PointsMarketplace from "./pages/Olx/olx_buy"
import SellPage from "./pages/Olx/olx_sell"
import TransferActivityPoint from "./pages/Olx/transfer";

import VirtualPage from "./pages/Myads/VirtualPage";
import Myincomenew from "./pages/Myincomesnewpages/Myincomenew";
import RepurchaseIncentive from "./pages/Activation/RepurchaseIncentive";
import Activepassnew from "./pages/Myincome/Activepassnew";
import Daily_income_new from "./pages/Dailyincome/Daily_income_new";
import Activation_income_report from "./pages/Dailyincome/Activation_income_report";
import WithdrawHistory from "./pages/Dailyincome/WithdrawHistory";
import Legal from "./pages/LegalDoc/legal";
import VirtualMallLogin from "./pages/VirtualMall/VirtualMallLogin";
import VirtualMallDashboard from "./pages/VirtualMall/VirtualMallDashboard";
import VirtualMallWithdraw from "./pages/VirtualMall/VirtualMallWithdraw";
import VirtualMallForgetPassword from "./pages/VirtualMall/VirtualMallForgetPassword";
import UserPoints from "./pages/UserPoints/UserPoints";
import VirtualMall from "./pages/VirtualMall/VirtualMall";
import ShopProducts from "./pages/VirtualMall/ShopProducts";
import Cart from "./pages/VirtualMall/Cart";

const AppRoutes = () => {
  const location = useLocation();

  // Define the paths where Header should be hidden
  const hideHeaderPaths = ["/my_ads", "/"];
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname);

  // useEffect(() => {
  //   onMessage(messaging, (payload) => {
  //     console.log(payload, "payloaddddd");
  //     toast.success(payload.notification.body);
  //   });
  //   generateToken();
  // }, []);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={3}
        style={{ width: "auto", minWidth: "300px", maxWidth: "450px" }}
      />
      <CartProvider>
        <Auth>
          {shouldShowHeader && <Header />}

        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/" element={<Login />} /> */}
          <Route path="/register" element={<Register />} />
          <Route path="/income" element={<Dailyincome />} />
          <Route path="/Daily_income_new" element={<Daily_income_new />} />
          <Route path="/Activation_income_report" element={<Activation_income_report />} />
          <Route path="/my_income" element={<Myincome />} />
          <Route path="/my_inco" element={<Myincomenew />} />
          <Route path="/WithdrawHistory" element={<WithdrawHistory />} />
          <Route path="/my_profile" element={<Myprofile />} />
          <Route path="/my_rank" element={<Myrank />} />
          <Route path="/my_team" element={<Myteam />} />
          <Route path="/home" element={<Home />} />
          <Route path="/post_login" element={<Postlogin />} />
          <Route path="/forgot" element={<Forgot />} />
          <Route path="/otp" element={<Otp />} />
          <Route path="/logotp" element={<Logotp />} />
          <Route path="/new_password" element={<Newpassword />} />
          <Route path="/change_password" element={<Newpassword />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/legal" element={<Legal />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/my-products" element={<Products />} />
          <Route path="/achivers" element={<Achivers />} />
          <Route path="/Widthhistory" element={<Widthhistory />} />
          <Route path="/Upgradehistory" element={<Upgradehistory />} />
          <Route path="/Activation" element={<Activation />} />
          <Route path="/VirtualMallWithdraw" element={<VirtualMallWithdraw />} />
          <Route path="/Addtransaction" element={<Addtransaction />} />
          <Route path="/Setpin" element={<Setpin />} />
          <Route path="/Resetpin" element={<Resetpin />} />
          {/* <Route path="/Status" element={<Wahtsappstatus />} /> */}
          <Route path="/Activepass" element={<Activepass />} />
          <Route path="/Chat" element={<ChatList />} />
          <Route path="/ChatView/:c_id" element={<ChatView />} />
          <Route path="/MyProject" element={<MyProject />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route
            path="/Repurchasetransaction"
            element={<Repurchasetransaction />}
          />
          <Route
            path="/RepurchaseIncentive"
            element={<RepurchaseIncentive />}
          />
          <Route path="/my_ads" element={<MyAdvertisements />} />
          <Route path="/user-points" element={<UserPoints />} />
          <Route path="/my_status" element={<VirtualPage />} />
          <Route path="/olx_front" element={<BuySellButtons />} />
          <Route path="/olx_buy" element={<PointsMarketplace />} />
          <Route path="/olx_sell" element={<SellPage />} />
          <Route path="/Activepass_secure" element={<Activepassnew />} />
          <Route path="/olx_transfer" element={<TransferActivityPoint />} />
          <Route path="/virtual_mall_login" element={<VirtualMallLogin />} />
          <Route path="/virtual_mall_dash" element={<VirtualMallDashboard />} />
          <Route path="/virtual_mall_forget_password" element={<VirtualMallForgetPassword />} />
          <Route path="/virtual-mall" element={<VirtualMall />} />
          <Route path="/shop-products" element={<ShopProducts />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </Auth>
    </CartProvider>
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
